import Head from "next/head";
import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";

export default function Storelocator() {
  const iframeRef = useRef();
  const [basket, setBasket] = useState();
  const [lang, setLang] = useState("");
  const router = useRouter();

  useEffect(() => {
    const baskets = window.sessionStorage.getItem("basketInfo");
    if (!baskets) {
      router.push("/baskets");
    }
  }, [router]);

  useEffect(() => {
    const topLevelDomain = window.location.hostname.split(".").pop();
    setLang(topLevelDomain === "es" ? "es" : "fr");
  }, []);

  useEffect(() => {
    setBasket(JSON.parse(sessionStorage.getItem("basketInfo")));
  }, []);

  useEffect(() => {
    if (iframeRef.current && basket) {
      iframeRef.current.contentWindow.postMessage(
        basket,
        `${process.env.NEXT_PUBLIC_STORE_LOCATOR_URL}.${lang}`
        // "http://localhost:3002"
      );
    }
  }, [basket, lang]);

  return (
    <>
      <Head>
        <title>Bene Bono</title>
      </Head>
      <iframe
        id="test"
        ref={iframeRef}
        style={{
          display: "block",
          minHeight: "100vh",
          border: "none",
          overflow: "hidden",
        }}
        height="100%"
        width="100%"
        src={`${
          process.env.NEXT_PUBLIC_STORE_LOCATOR_URL
        }.${lang}?basket=${encodeURIComponent(JSON.stringify(basket))}`}
        // src={`http://localhost:3002?basket=${encodeURIComponent(
        //   JSON.stringify(basket)
        // )}`}
        onLoad={() =>
          iframeRef.current.contentWindow.postMessage(
            basket,
            `${process.env.NEXT_PUBLIC_STORE_LOCATOR_URL}.${lang}`
          )
        }
      ></iframe>
    </>
  );
}
